/* eslint-disable */
const StageTrackerConnector2 = ({ isActive }) => {
  let backgroundColor = "bg-color-raindrop-minor";

  if (isActive) {
    backgroundColor = "bg-color-raindrop-primary";
  }

  return <div className={`w-full px-2 h-1 rounded-full ${backgroundColor}`} />;
};

const StageTrackerBall2 = ({ isActive, isSelected }) => {
  let backgroundColor = "bg-color-raindrop-minor";
  let scaleInner = "scale-100";
  let dimensionsInner = "w-3 h-3";

  if (isSelected) {
    backgroundColor = "bg-color-raindrop-primary";
    dimensionsInner = "w-5 h-5";
  }

  if (isActive) {
    backgroundColor = "bg-color-raindrop-primary";
  }

  return (
    <div className="flex flex-col items-center justify-center w-fit ">
      <div
        id="ball-inner"
        className={`${dimensionsInner} rounded-full ${backgroundColor} ${scaleInner} transition-all`}
      />
    </div>
  );
};

const StageTracker = ({ numberOfStages, stageIndex }) => {
  const repeatedElements = Array(numberOfStages - 1).fill(null);

  const fixedPercentage = 20;
  const proportion = stageIndex / (numberOfStages - 1);
  let progressPercentage =
    fixedPercentage + (100 - fixedPercentage) * proportion;

  const isCompleted = stageIndex === numberOfStages - 1;

  let flashBar = "opacity-0";
  if (isCompleted) {
    flashBar = "animate-ping-once opacity-100";
  }
  return (
    <div className="flex flex-col justify-center items-center w-full gap-2">
      <div className="flex flex-col w-1/2 relative">
        <div className="w-full h-4 dark:bg-color-dark-background-secondary bg-color-background-tertiary rounded-full" />
        <div
          className={`w-full h-4  bg-color-raindrop-primary rounded-full transition-all duration-300  absolute ${flashBar}`}
        />
        <div
          className={`h-4 bg-color-raindrop-primary rounded-full absolute transition-all`}
          style={{
            width: `${progressPercentage}%`,
          }}
        />
      </div>
      {/* <div className="flex flex-row w-1/2 h-fit items-center justify-center gap-2">
        <StageTrackerBall2
          isActive={0 < stageIndex}
          isSelected={0 === stageIndex}
        />
        {repeatedElements.map((_, index) => (
          <>
            <StageTrackerConnector2 isActive={index + 1 <= stageIndex} />
            <StageTrackerBall2
              isActive={index + 1 < stageIndex}
              isSelected={index + 1 === stageIndex}
            />
          </>
        ))}
      </div> */}
    </div>
  );
};

export default StageTracker;
